<template>
	<div class="bkf7 gameall_list" v-if="login && isAdmin">
		<el-container>
			<div class="inter2">
				<div class="filter-keywords-search" v-if="!isMobile">
					<div class="filter-search-label">关键词</div>
					<div class="filter-search-info">
						<div class="filter-search-input el-input el-input--suffix">
							<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入管理员昵称"
								class="el-input__inner"><span class="el-input__suffix">
								<span class="el-input__suffix-inner" @click="Search">
									<div class="search">搜索</div>
								</span></span>
						</div>
					</div>
				</div>
				
				<div class="action-bar">
					<el-button type="primary" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 5px; padding: 10px 20px;" @click="openDialog()">新增管理员</el-button>
				</div>

				<div v-if="isMobile">
					<div class="mobile-action-bar" style="display: flex; gap: 10px; padding: 10px;">
						<el-button type="primary" style="flex: 1; background: #1f9535; border-color: #1f9535; color: #fff;" @click="openDialog()">新增管理员</el-button>
					</div>
					<div class="mobile_kefu_list">
						<div class="kefu_item" v-for="(item, index) in list" :key="index">
							<div class="kefu_info">
								<div class="kefu_row">
									<span class="label">ID：</span>
									<span class="value">{{ item.id }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">用户名：</span>
									<span class="value">{{ item.username }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">昵称：</span>
									<span class="value">{{ item.nickname }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">状态：</span>
									<span class="value">{{ item.status === 'normal' ? '正常' : '禁用' }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">创建时间：</span>
									<span class="value">{{ formatTime(item.createtime) }}</span>
								</div>
							</div>
							<div class="kefu_actions">
								<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click="openDialog(item)">修改</el-button>
								<el-button size="mini" style="background: #ff4d4f; border-color: #ff4d4f; color: #fff; border-radius: 3px;" @click="deleteAdmin(item.id)">删除</el-button>
							</div>
						</div>
						<div v-if="list.length === 0" class="empty_tip">暂无管理员数据</div>
					</div>
				</div>
				<el-table v-else :data="list" border style="width: 100%">
					<el-table-column prop="id" label="ID" width="80">
					</el-table-column>
					<el-table-column prop="username" label="用户名" min-width="120">
					</el-table-column>
					<el-table-column prop="nickname" label="昵称" min-width="150">
					</el-table-column>
					<el-table-column prop="status" label="状态" width="100">
						<template slot-scope="scope">
							<el-tag :type="scope.row.status === 'normal' ? 'success' : 'danger'" size="small">
								{{ scope.row.status === 'normal' ? '正常' : '禁用' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="createtime" label="创建时间" min-width="180">
						<template slot-scope="scope">
							{{ formatTime(scope.row.createtime) }}
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="openDialog(scope.row)">修改</el-button>
							<el-button type="text" size="small" style="color: #F56C6C;" @click="deleteAdmin(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-size="limit"
					layout="total, prev, pager, next"
					:total="total">
				</el-pagination>
			</div>
		</el-container>
		
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="dialogClose">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px">
				<el-form-item label="用户名" prop="username">
					<el-input v-model="form.username" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="昵称" prop="nickname">
					<el-input v-model="form.nickname" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item label="密码" :prop="form.id ? '' : 'password'">
					<el-input v-model="form.password" type="password" :placeholder="form.id ? '留空则不修改密码' : '请输入密码'"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确定</el-button>
			</span>
		</el-dialog>
	</div>
	<div v-else-if="login && !isAdmin">
		<div class="content">
			<p>无权限访问</p>
		</div>
	</div>
	<div v-else>
		<div class="content">
			<p>请先登录</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				page: 1,
				limit: 20,
				total: 0,
				keyword: '',
				dialogVisible: false,
				dialogTitle: '新增管理员',
				form: {
					id: null,
					username: '',
					nickname: '',
					password: ''
				},
				rules: {
					username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
					nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
					password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
				}
			}
		},
		computed: {
			login() {
				return this.$store.getters.login
			},
			isMobile() {
				return this.$store.getters.isMobile
			},
			isAdmin() {
				return this.$store.getters.isAdmin
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList() {
				this.rq.requests.post('api/game/hall/getAdminList', {
					page: this.page,
					limit: this.limit,
					keyword: this.keyword
				}).then(res => {
					if (res.code === 1 && res.data) {
						this.list = res.data.data || []
						this.total = res.data.total || 0
					}
				}).catch(err => {
					console.error('获取管理员列表失败:', err)
				})
			},
			Search() {
				this.page = 1
				this.getList()
			},
			handleCurrentChange(val) {
				this.page = val
				this.getList()
			},
			openDialog(row) {
				if (row) {
					this.dialogTitle = '修改管理员'
					this.form = {
						id: row.id,
						username: row.username,
						nickname: row.nickname,
						password: ''
					}
					this.rules.password = []
				} else {
					this.dialogTitle = '新增管理员'
					this.form = {
						id: null,
						username: '',
						nickname: '',
						password: ''
					}
					this.rules.password = [{ required: true, message: '请输入密码', trigger: 'blur' }]
				}
				this.dialogVisible = true
			},
			dialogClose() {
				this.$refs.form.resetFields()
			},
			submitForm() {
				this.$refs.form.validate(valid => {
					if (valid) {
						if (this.form.id) {
							this.rq.requests.post('api/game/hall/updateAdmin', this.form).then(res => {
								if (res.code === 1) {
									this.$message.success('修改成功')
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.msg || '修改失败')
								}
							})
						} else {
							this.rq.requests.post('api/game/hall/addAdmin', this.form).then(res => {
								if (res.code === 1) {
									this.$message.success('添加成功')
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.msg || '添加失败')
								}
							})
						}
					}
				})
			},
			deleteAdmin(id) {
				this.$confirm('确定要删除该管理员吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.rq.requests.post('api/game/hall/deleteAdmin', { id: id }).then(res => {
						if (res.code === 1) {
							this.$message.success('删除成功')
							this.getList()
						} else {
							this.$message.error(res.msg || '删除失败')
						}
					})
				}).catch(() => {})
			},
			formatTime(timestamp) {
				if (!timestamp && timestamp !== 0) return '-'
				try {
					return this.$moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss')
				} catch(e) {
					return '-'
				}
			}
		}
	}
</script>

<style scoped>
	.bkf7 {
		background: #f7f7f7;
		min-height: 100vh;
	}
	
	.gameall_list {
		padding: 20px;
	}
	
	.inter2 {
		background: #fff;
		padding: 20px;
		border-radius: 5px;
	}
	
	.filter-keywords-search {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.filter-search-label {
		margin-right: 10px;
		font-size: 14px;
		color: #333;
	}
	
	.filter-search-info {
		flex: 1;
		max-width: 300px;
	}
	
	.search {
		width: 60px;
		text-align: center;
		cursor: pointer;
		background: #1f9535;
		color: #fff;
		line-height: 40px;
	}
	
	.action-bar {
		margin-bottom: 20px;
	}
	
	.mobile_kefu_list {
		padding: 10px;
	}
	
	.kefu_item {
		background: #fff;
		border: 1px solid #eee;
		border-radius: 5px;
		padding: 15px;
		margin-bottom: 10px;
	}
	
	.kefu_info {
		margin-bottom: 10px;
	}
	
	.kefu_row {
		display: flex;
		margin-bottom: 5px;
		font-size: 14px;
	}
	
	.kefu_row .label {
		color: #666;
		min-width: 80px;
	}
	
	.kefu_row .value {
		color: #333;
		flex: 1;
		word-break: break-all;
	}
	
	.kefu_actions {
		display: flex;
		gap: 10px;
		justify-content: flex-end;
	}
	
	.qrcode-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.qrcode-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.qrcode-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
	}
	
	.qrcode-preview {
		width: 148px;
		height: 148px;
		display: block;
	}
	
	.empty_tip {
		text-align: center;
		padding: 40px;
		color: #999;
	}
</style>